import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'

// COMPONENT
import * as styled from '../style/main.style'
import Header from '../Header'
import Navbar from '../Navbar'
import TableCustom from '../../../component/table/tableCustom'
import TableRowCommon from '../../../component/table/TableRowCommon'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

type Props = {}



let mockData = [
    {
        id: 1,
        report: "บัญชีสรุปผลการติดตามและประเมินผลแผนพัฒนาท้องถิ่น",
        path: "/auth/report/tracking-summary-account",
        isView: true
    },
    {
        id: 2,
        report: "รายงานบัญชีครุภัณฑ์",
        path: "/auth/report/equipment-account",
        isView: true
    },
    {
        id: 3,
        report: "รายงานการแสดงผลสัมฤทธิ์การดำเนินงาน",
        path: "/auth/report/operational-achievements",
        isView: true
    },
    {
        id: 4,
        report: "รายงานผลการใช้จ่ายงบประมาณ",
        path: "/auth/report/budget-spending",
        isView: true
    },
    {
        id: 5,
        report: "รายงานการแสดงผลความสำเร็จของโครงการ",
        path: "/auth/report/project-success",
        isView: true
    },
    {
        id: 6,
        report: "รายงานความคืบหน้าโครงการ สถานะแถบสีได้อย่างน้อย 5 ระดับ",
        path: "/auth/report/project-progress",
        isView: true
    },

]


const Report: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const headCells = [
        {
            id: "RANK", disablePadding: false, align: 'center', width: 100, label: "ลำดับ"
        },
        {
            id: "PROJECT", disablePadding: false, align: "center", width: 800, label: "รายงาน"
        },
        {
            id: "STATUS", disablePadding: false, align: "right", label: ""
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, report, path, isView } =
            objData;

        const objRenderData = {
            key: id,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: id },
                {
                    option: "TEXT",
                    align: "left",
                    label: report || "-",
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    component: (
                        <div className={`text-left h-full w-full flex justify-end ${!isView && 'hidden'}`}>
                            <Link to={path} className='flex gap-x-3'>
                                <RemoveRedEyeOutlinedIcon className='text-base_disable cursor-pointer' />
                                <Typography>{t("BUTTON.VIEW")}</Typography>
                            </Link>
                        </div >
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    return (
        <styled.ContainerHome>
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section>
                        <Typography className='text-primary' variant='h4'>
                            {"รายงาน"}
                        </Typography>
                    </section>
                    <section className='w-full mt-3'>
                        <TableCustom
                            tableFixedWidth
                            tableMinWidth={1000}
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy=""
                            sortType="ASC"
                            headCells={headCells}
                            rowCount={totalPage}
                            rowsData={mockData && mockData.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                            hidePagination
                        />
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default Report
